import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "paystack"
    }}>{`Paystack`}</h2>
    <p>{`Paystack is a Nigerian fintech company that provides online payment solutions for businesses. It offers a range of services, including online and offline payments, subscriptions, and invoicing. Paystack's platform enables businesses to easily and securely accept payments from customers via credit card, debit card, and mobile money.`}</p>
    <h3 {...{
      "id": "paystack-integrate-inside-pickbazar"
    }}>{`Paystack integrate inside PickBazar.`}</h3>
    <p>{`Please follow & complete this steps for Paystack integration for your e-commerce system.`}</p>
    <ul>
      <li parentName="ul">{`First go to settings from PickBazar admin dashboard. Inside settings you will find Currency option.Select your Currency. If you want to Test development on localhost.then Select South African Rand(ZAR).`}</li>
    </ul>
    <p><img alt="settings-currency" src={require("../images/payment-images/settings-currency.png")} /></p>
    <p>{`Here is a breakdown of countries and the currencies they can accept payments in.`}</p>
    <p><img alt="paystack-suported-currency" src={require("../images/payment-images/paystack-suported-currency.png")} /></p>
    <p>{`For more information: `}<a parentName="p" {...{
        "href": "https://support.paystack.com/hc/en-us/articles/360009973779-What-currency-is-available-to-my-business-"
      }}>{`Paystack currency is available`}</a>{`. `}</p>
    <ul>
      <li parentName="ul">{`Inside api there is `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file. You have to copy & paste this line of codes inside the `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file. We will discuss later about how to create those API keys in `}<a parentName="li" {...{
          "href": "https://paystack.com/"
        }}>{`Paystack official website`}</a>{`.`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`PAYSTACK_PUBLIC_KEY=[YOUR_PAYSTACK_PUBLIC_KEY]
PAYSTACK_SECRET_KEY=[YOUR_PAYSTACK_SECRET_KEY]
PAYSTACK_PAYMENT_URL=https://api.paystack.co
MERCHANT_EMAIL=[YOUR_PAYSTACK_MERCHANT_EMAIL]
`}</code></pre>
    <ul>
      <li parentName="ul">{`Add Paystack publishable key inside pickbazar shop.`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`NEXT_PAYSTACK_PUBLIC_KEY=[YOUR_YOUR_PAYSTACK_PUBLIC_KEY]
`}</code></pre>
    <b>SHOP_URL=[YOUR_SHOP_URL]</b> This parameter is must have in .env file when Paystack is using. Otherwise the payment redirection will be broken.
    <h2 {...{
      "id": "paystack-webhook-settings"
    }}>{`Paystack Webhook settings`}</h2>
    <ul>
      <li parentName="ul">{`To activate Paystack go to settings from PickBazar admin dashboard. Inside settings you will find configure payment option. (e.g. Paystack Webhook URL is coming from local development. This static link will dynamically generated in live environment)`}</li>
    </ul>
    <p><img alt="admin-pickbazar-settings" src={require("../images/payment-images/admin-settings.jpg")} />{`
`}<img alt="paystack-pickbazar-dashboard" src={require("../images/payment-images/paystack-webhook.png")} /></p>
    <ul>
      <li parentName="ul">{`Copy the webhook url & registered in Paystack Dashboard.`}</li>
    </ul>
    <p><img alt="save-webhook" src={require("../images/payment-images/save-webhook.png")} /></p>
    <ul>
      <li parentName="ul">{`If you want to use webhook during development on localhost, you must use a tools like ngrok to have the webhooks delivered to your local machine.`}</li>
    </ul>
    <p><img alt="ngrok" src={require("../images/payment-images/ngrok.png")} /></p>
    <ul>
      <li parentName="ul">{`Copy the forwarding https link & paste on Test Webhook URL, after paste forwarding https link, add line- /webhooks/paystack.`}</li>
    </ul>
    <p><img alt="paystack-localhost-webhooks" src={require("../images/payment-images/paystack-localhost-webhooks.png")} /></p>
    <h2 {...{
      "id": "how-to-create--setup-paystack-information-properly"
    }}>{`How to create & setup Paystack information properly?`}</h2>
    <ul>
      <li parentName="ul">{`Go to the `}<a parentName="li" {...{
          "href": "https://paystack.com/"
        }}>{`Paystack official website`}</a>{` & login  If you aren't a registered user, Complete the Paystack registration first.`}</li>
      <li parentName="ul">{`After logged in into Paystack dashboard, Click on Settings.`}</li>
    </ul>
    <p><img alt="paystack-dashboard" src={require("../images/payment-images/paystack-dashboard.png")} /></p>
    <ul>
      <li parentName="ul">{`After That Click on API Keys & Webhooks for Paystack Secret Key & Paystack Public Key.`}</li>
    </ul>
    <p><img alt="paystack-api-keys" src={require("../images/payment-images/paystack-api-keys.png")} /></p>
    <ul>
      <li parentName="ul">{`Copy & paste those inside PickBazar API and PickBazar Shop `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file like mentioned above.`}</li>
    </ul>
    <h2 {...{
      "id": "special-notes-for-paystack"
    }}>{`Special Notes for Paystack.`}</h2>
    <p>{`If we have used any third party system/plugin/packages, then we have always encouraged our respected customers to follow the official documentation for detailed & in-depth knowledge.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://paystack.com/docs"
        }}>{`Paystack official documentation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://paystack.com/docs/payments/webhooks"
        }}>{`Paystack Webhooks documentation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://support.paystack.com/hc/en-us/articles/360009973799-Can-I-accept-payments-in-USD-"
        }}>{`Accept Payments in US Dollars (USD)`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      